/**
 * Redux actions for resource-level admin permissions (e.g., SEE_SITE_USERS, MODIFY_USERS).
 * Used by entity actions (e.g., SiteUserEditGroupMembershipEntityAction) to check clickability.
 */

export const FETCH_RESOURCE_ACTIONS_REQUEST = 'FETCH_RESOURCE_ACTIONS_REQUEST';
export const FETCH_RESOURCE_ACTIONS_SUCCESS = 'FETCH_RESOURCE_ACTIONS_SUCCESS';
export const FETCH_RESOURCE_ACTIONS_FAILURE = 'FETCH_RESOURCE_ACTIONS_FAILURE';

export interface FetchResourceActionsRequestAction {
  type: typeof FETCH_RESOURCE_ACTIONS_REQUEST;
}

export interface FetchResourceActionsSuccessAction {
  type: typeof FETCH_RESOURCE_ACTIONS_SUCCESS;
  payload: Record<string, string[]>;
}

export interface FetchResourceActionsFailureAction {
  type: typeof FETCH_RESOURCE_ACTIONS_FAILURE;
  error: string;
}

/** Union of all resource actions; used by reducer and saga for type safety. */
export type ResourceActionTypes =
  | FetchResourceActionsRequestAction
  | FetchResourceActionsSuccessAction
  | FetchResourceActionsFailureAction;

/**
 * Dispatched by an Admin Space ex: AllSiteUsersAndIdentitiesSpace in componentDidMount
 * when entering the Users space.
 */
export function fetchResourceActions(): FetchResourceActionsRequestAction {
  return { type: FETCH_RESOURCE_ACTIONS_REQUEST };
}

/**
 * Dispatched by ResourceActionsSaga on successful API response.
 */
export function fetchResourceActionsSuccess(
  payload: Record<string, string[]>
): FetchResourceActionsSuccessAction {
  return { type: FETCH_RESOURCE_ACTIONS_SUCCESS, payload };
}

/**
 * Dispatched by ResourceActionsSaga when the API call fails.
 */
export function fetchResourceActionsFailure(error: string): FetchResourceActionsFailureAction {
  return { type: FETCH_RESOURCE_ACTIONS_FAILURE, error };
}
